import * as React from 'react'

import type moment from 'moment'

import { observer } from 'mobx-react'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { useSelectionState } from 'modules/shift_management/hooks/useSelection'
import type { EmployeeWithShifts, Shift, ShiftsRow } from 'modules/shift_management/lib/types'
import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

import DisabledNightShiftItem from '../DisabledNightShiftItem'
import ShiftLayout from './ShiftLayout'

interface Props {
  shiftsRow: ShiftsRow
  shift: Shift
  date: moment.Moment
  employee: EmployeeWithShifts
  isNightShift: boolean
  previewPlannedBreaks?: PlannedBreak[] | null
  preview: boolean
  contractVersions: ContractVersions
}

const BaseShift = ({
  shiftsRow,
  shift,
  employee,
  date,
  isNightShift,
  previewPlannedBreaks = null,
  preview = false,
  contractVersions,
}: Props) => {
  // Keep these selection hooks here, using this wrapper to be re-rendered
  // but we avoid to re-render the children unless the isSelected prop changes.
  const { isEnabled: isSelectionEnabled, shifts } = useSelectionState()
  const isSelected = !!(employee.canManage && shifts[shift.referenceKey(date)])
  if (isNightShift) return <DisabledNightShiftItem nightShift={shift} date={date} />

  return (
    <ShiftLayout
      shiftsRow={shiftsRow}
      shift={shift}
      date={date}
      employee={employee}
      isSelectionEnabled={isSelectionEnabled}
      isSelected={isSelected}
      previewPlannedBreaks={previewPlannedBreaks}
      preview={preview}
      contractVersions={contractVersions}
    />
  )
}

export default observer(BaseShift)
